module.exports = __webpack_public_path__ + "static/media/13.10c5a812.jpg";